/************** EVENT GRID ****************/

// EVENT GRID
var checkedCities, uncheckedCities;
var checkedCourses, uncheckedCourses;
var checkedAges, uncheckedAges;

function initEventGrid() {
//INITIALIZE
citySelectionChanged();
courseSelectionChanged();
ageSelectionChanged();

changeEventGrid();
$.cookie('event_cities_selection', checkedCities, { expires: 365 });

//DETECT CITY CHANGES AND THEN MODIFY THE GRID
$('.events-cities input[type=checkbox]').change(function() {
  citySelectionChanged();
  changeEventGrid();
  $.cookie('event_cities_selection', checkedCities, { expires: 365 });
});

//DETECT COURSE CHANGES AND THEN MODIFY THE GRID
$('.events-courses input[type=checkbox]').change(function() {
  courseSelectionChanged();
  changeEventGrid();
});

//DETECT AGE CHANGES AND THEN MODIFY THE GRID
$('.events-ages input[type=checkbox]').change(function() {
  ageSelectionChanged();
  changeEventGrid();
});
}

function changeEventGrid() {
  var speed = 'medium';
  //PROCESS COURSES FIRST, THEN CITIES
  //SHOW ALL COURSES WHERE THE OTHER ATTRIBUTE IS NOT CHECKED
  $(checkedAges.join()).not(uncheckedCities.join()).not(uncheckedCourses.join()).show(speed);
  $(uncheckedAges.join()).hide(speed);

  $(checkedCourses.join()).not(uncheckedCities.join()).not(uncheckedAges.join()).show(speed);
  $(uncheckedCourses.join()).hide(speed);

  $(checkedCities.join()).not(uncheckedCourses.join()).not(uncheckedAges.join()).show(speed);
  $(uncheckedCities.join()).hide(speed);
  
  setTimeout(
  function() 
  {
    toggleNoEvents();
  }, 500);
}

function citySelectionChanged() {
//EMPTY GLOBAL ARRAYS
checkedCities = [];
uncheckedCities = [];

//FIND ELEMENTS TO PUSH TO THE ARRAYS
$('.events-cities input[type=checkbox]:checked').map(function() {
  checkedCities.push('.events-' + $(this).attr('city'));
});

$('.events-cities input[type=checkbox]:not(:checked)').map(function() {
  uncheckedCities.push('.events-' + $(this).attr('city'));
});
}

function courseSelectionChanged() {
  checkedCourses = [];
  uncheckedCourses = [];

  $('.events-courses input[type=checkbox]:checked').map(function() {
    checkedCourses.push('.events-' + $(this).attr('course'));
  });

  $('.events-courses input[type=checkbox]:not(:checked)').map(function() {
    uncheckedCourses.push('.events-' + $(this).attr('course'));
  });
}

function ageSelectionChanged() {
  checkedAges = [];
  uncheckedAges = [];

  $('.events-ages input[type=checkbox]:checked').map(function() {
    checkedAges.push('.age-' + $(this).attr('age'));
  });

  $('.events-ages input[type=checkbox]:not(:checked)').map(function() {
    uncheckedAges.push('.age-' + $(this).attr('age'));
  });
}

function toggleNoEvents() {
 var shown = $('.product-panel:visible').size();
  if (shown == 0) {
   $('.no-events').show("fast");
  } else {
   $('.no-events').hide("fast"); 
  }
}


/************** General Init ****************/

function initialize() {
  var selection = $.cookie('event_cities_selection');

  var cityParam = getParam('city');
  if (cityParam != undefined && cityParam != null && cityParam != "") {
    selection = '.events-' + decodeURI(cityParam);
    $.cookie('event_cities_selection', selection, { expires: 365 });
  }

  if (selection != undefined && selection != "") {
    checkedCities = selection.split(',');
    checkBoxes();
    initEventGrid();
  } else {
    geoLocate();
  }
}

function checkBoxes() {
  var selection = $.cookie('event_cities_selection').split(',');
  for (var idx = 0; idx < selection.length; idx++) {
    $('input[city="' + selection[idx].replace('.events-','') + '"]').prop('checked',true);
  }
}

function alertEvent(firstTime, city) {
  if (firstTime) {
    var alertString = $('.event-alert .alert-content').html().replace('$$city$$', capitaliseFirstLetter(city));
    $('.event-alert .alert-content').html(alertString);
    $('.event-alert').show();
  }
}

function getParam(name) {
  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
  var regexS = "[\\?&]"+name+"=([^&#]*)";
  var regex = new RegExp( regexS );
  var results = regex.exec( window.location.href );
  if( results == null )
    return "";
  else
    return results[1];
}

/************** GeoLocations ****************/

function geoLocate(){

  //Check if initial GeoLocation Worked, otherwise fallback
  var location = $.cookie('browser_location');
  if (location != null && location != "") {
    $('input[city="' + location.toLowerCase() + '"]').prop('checked', true);
    alertEvent(true, location);
    initEventGrid();

  } else {
    
    $.ajax({
      url: 'http://freegeoip.net/json/',
      type: 'POST',
      dataType: 'jsonp',
      success: function (location) {
      	var city = data["city"];
        if ($('input[city="' + location.city.toLowerCase() + '"]').length > 0) {
          $('input[city="' + location.city.toLowerCase() + '"]').prop('checked', true);
        } else {
          city = findClosestCity(location.latitude, location.longitude);
          $('input[city="' + city + '"]').prop('checked', true);
        }
        alertEvent(true,city);
        initEventGrid();
      }
     });
    
  }
}

/************** INITIALIZE ****************/

$(document).ready(function() {
  $('.product-panel').hide();
  initialize();
});
